import { useState, useEffect } from 'react';
import { MotifButton, MotifTextLink, MotifIcon, MotifChip } from '@ey-xd/motif-react';
import { MotifTabNavigation as MotifTabNav, MotifTabControl } from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Gcsp_Opp_View_State,
  Recoil_Gcsp_Quarter_State,
  Recoil_Selected_Account_State,
  Gcsp_Active_Tab_State,
  Pl_Failure_Modal_State,
  Pl_Submit_Success_Modal_State,
  Current_User,
  Recoil_All_Accounts_Quarter_State,
  Active_Tab_Gcsp,
  System_Date_Time_State,
  All_Month_Data_State,
  Next_Button_Active_State,
} from '../../../../recoil/recoil';
import { actionIcLaunch24px } from '@ey-xd/motif-react/assets/icons';
import SubmitConformationModal from '../../../organisms/modals/submitConformationModal';
import { getGcspOpportunitiesDue, postGCSPJudgeData } from '../../../../services/gcspServices';
import {
  dateFormat,
  structureMonth,
  QuarterNumber,
  dateFormatMonth,
  getPeriodForMonth,
  getCurrentMonth,
} from '../../../../util/commonUtil';

import {
  SubmitButtonContainer,
  Hyperlink,
  QuarterTitle,
  QuarterDates,
  HyperlinkText,
  Divider,
  TitleContainer,
  TitleTextContainer,
  SubHeaderContainerGcsp,
  TabStep,
  TabMonth,
  TabDates,
  TabPrevButton,
  TabNextButton,
} from '../../../atoms/subHeaderText/subHeader.styles';
import { BUTTON_TITLE, PAGE, SAM, SUB_HEADER } from '../../../../constants/commonConstants';
import { getAlertBarDetails, isCurrentUserExist } from '../../../../util/commonFunctions';
import FailureTransactionModal from '../../../organisms/modals/failureTransactionModal';
import SuccessTransactionModal from '../../../organisms/modals/SuccessTransactionModal';
import Button from '../../../atoms/button';
import './../styles/tableHeaderStyle.css';
import { ACTIVE_TAB_GCSP } from '../../../../recoil/recoilKeys';
import CustomSubmitAcknowledgmentModal from '../../../organisms/modals/customSubmitAcknowledgmentModal';
import { getLogOutStatus } from '../../../../services/commonServices';
import { useNavigate } from 'react-router-dom';

const SubHeaderGcsp = () => {
  const [customSubmitMessage, setCustomSubmitMessage] = useState({
    show: false,
    headerText: undefined,
    message: undefined,
  });
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Gcsp_Quarter_State);
  const [selectedAccount, setSelectedAccount] = useRecoilState(Recoil_Selected_Account_State);
  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Opp_View_State);
  const [data, setData] = useState({});
  const [showFailureSubmitModal, setShowFailureSubmitModal] =
    useRecoilState(Pl_Failure_Modal_State);
  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useState(false);
  const [showSubmitSuccessModal, setShowSubmitSuccessModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );
  const [activeTab, setActiveTab] = useRecoilState(Gcsp_Active_Tab_State);
  const currentUser = useRecoilValue(Current_User);
  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const [allMonthData, setAllMonthData] = useRecoilState(All_Month_Data_State);
  const [systemDateTime, setSystemDateTime] = useRecoilState(System_Date_Time_State);
  const [tabActive, setTabActive] = useRecoilState(Active_Tab_Gcsp);
  const [nextButtonActive, setNextButtonActive] = useRecoilState(Next_Button_Active_State);
  const [quarterChipInfo, setQuarterChipInfo] = useState({});
  const [monthChipInfo, setMonthChipInfo] = useState({});
  let alertStatusDetails;
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser != null) {
      getGcspOpportunitiesDue(currentUser.email, systemDateTime)
        .then(result => {
          setQuarterData(result);
        })
        .catch(error => {});
    }
  }, [currentUser]);

  useEffect(() => {
    if (quarterData != null && currentUser != null && allAccountsQuarterData != null) {
      getMotifChip();
    }
  }, [quarterData, currentUser, allAccountsQuarterData]);

  const quarter = quarterData ? QuarterNumber(quarterData.quarter) : '';
  const month = quarterData ? quarterData.month : '';
  const SecondMonth = quarterData ? quarterData.next_month : '';
  const ThirdMonth = quarterData ? quarterData.next2next_month : '';
  const currentYear = quarterData ? quarterData.fiscal_year : '';
  const StartDate = quarterData ? dateFormatMonth(quarterData.current_month_start_date) : '';
  const EndDate = quarterData ? dateFormatMonth(quarterData.current_month_end_date) : '';
  const SecondMonthStartDate = quarterData
    ? dateFormatMonth(quarterData.next_month_start_date)
    : '';
  const SecondMonthEndDate = quarterData ? dateFormatMonth(quarterData.next_month_end_dt_date) : '';
  const ThirdMonthStartDate = quarterData
    ? dateFormatMonth(quarterData.next2next_month_start_date)
    : '';
  const ThirdMonthEndDate = quarterData
    ? dateFormatMonth(quarterData.next2next_month_end_date)
    : '';
  const quarterStartDate = quarterData ? dateFormat(quarterData.quarter_start_date) : '';
  const quarterEndDate = quarterData ? dateFormat(quarterData.quarter_end_date) : '';
  const DueDate = quarterData ? quarterData.due_in : '';
  const DayString = quarterData && quarterData.due_in > 1 ? SUB_HEADER.DAYS : SUB_HEADER.DAY;
  const CurrentMonth = getCurrentMonth(systemDateTime);
  let TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  let personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  let personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  let IsSubmitDisabled = false;

  IsSubmitDisabled =
    !(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck) && tabActive === 2
      ? true // Disable
      : false; // Enable

  const getChipVariant = () => {
    if (DueDate === 0) {
      return 'error';
    } else if (!isNaN(parseInt(DueDate))) {
      if (parseInt(DueDate) > 6) {
        return 'warning';
      } else {
        return 'error';
      }
    }
    return 'defaultVariant';
  };

  const handleTabClick = tab => {
    setActiveTab(tab);
    let START_DATE, END_DATE, TYPE;
    if (tab === 'quarter') {
      START_DATE = quarterData ? dateFormat(quarterData.quarter_start_date) : '';
      END_DATE = quarterData ? dateFormat(quarterData.quarter_end_date) : '';
      TYPE = 'quarter';
    } else {
      START_DATE = quarterData ? dateFormat(quarterData.current_month_start_date) : '';
      END_DATE = quarterData ? dateFormat(quarterData.current_month_end_date) : '';
      TYPE = 'month';
    }
  };

  const getMotifChip = async () => {
    let apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setQuarterChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setMonthChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      console.error('Error fetching forecast submit status:', error);
    }
  };

  const handleTabKeyPress = (event, tab) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleTabClick(tab);
    }
  };

  const handleTabFocus = tab => {
    setActiveTab(tab);
  };

  const initSubmission = async () => {
    const isUserExist = await isCurrentUserExist();
    if (isUserExist) {
      setCustomSubmitMessage({
        show: true,
        headerText: SAM.title,
        message: SAM.message,
        closeButtonText: SAM.buttonText,
      });
    } else {
      getLogOutStatus(localStorage.getItem('userEmail'))
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          navigate('/logout');
        })
        .catch(error => {
          console.error('Error logging out:', error);
        });
    }
  };

  useEffect(() => {
    setTabActive(0);
  }, []);

  return (
    <SubHeaderContainerGcsp>
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingRight: 10, gap: 15 }}>
        <MotifTabNav>
          <MotifTabControl
            disabled
            className={tabActive === 0 ? 'motif-active' : ''}
            style={tabActive === 0 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 1: Final Forecast</TabStep>
            <TabMonth>
              {' '}
              Fiscal {month} ({getPeriodForMonth(month)}){' '}
            </TabMonth>
            <TabDates>
              {' '}
              {StartDate}- {EndDate}
            </TabDates>
          </MotifTabControl>

          <MotifTabControl
            disabled
            className={tabActive === 1 ? 'motif-active' : ''}
            style={tabActive === 1 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 2: Projected Forecast</TabStep>
            <TabMonth>
              Fiscal {SecondMonth} ({getPeriodForMonth(SecondMonth)})
            </TabMonth>
            <TabDates>
              {' '}
              {SecondMonthStartDate}- {SecondMonthEndDate}
            </TabDates>
          </MotifTabControl>

          <MotifTabControl
            disabled
            className={tabActive === 2 ? 'motif-active' : ''}
            style={tabActive === 2 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 3: Projected Forecast</TabStep>
            <TabMonth>
              Fiscal {ThirdMonth} ({getPeriodForMonth(ThirdMonth)})
            </TabMonth>
            <TabDates>
              {' '}
              {ThirdMonthStartDate}- {ThirdMonthEndDate}
            </TabDates>
          </MotifTabControl>
        </MotifTabNav>
      </div>

      <SubmitButtonContainer>
        <div style={{ padding: 20, display: 'flex' }}>
          <TabPrevButton>
            <MotifButton
              onClick={() => {
                setTabActive(tabActive - 1);
              }}
              disabled={tabActive === 0}
              style={
                tabActive === 0
                  ? { background: ' #FFFFFF', color: '#2E2E38', border: '1px solid #2E2E38' }
                  : {}
              }
              className="TabPrevButton"
            >
              Previous
            </MotifButton>
          </TabPrevButton>
          <TabNextButton>
            {nextButtonActive ? (
              <MotifButton
                onClick={() => {
                  if (tabActive < 2) {
                    setNextButtonActive(false);
                    setTabActive(tabActive + 1);
                  } else {
                    initSubmission();
                  }
                }}
                disabled={IsSubmitDisabled}
                className="TabNextButton"
              >
                {tabActive === 2 ? 'Submit' : 'Next'}
              </MotifButton>
            ) : (
              <MotifButton disabled={true} className="TabNextButton">
                Next
              </MotifButton>
            )}
            <CustomSubmitAcknowledgmentModal
              show={customSubmitMessage.show}
              headerText={customSubmitMessage.headerText}
              message={customSubmitMessage.message}
              bulletPoints={[SAM.bulletPoint1, SAM.bulletPoint2]}
              closeButtonText={customSubmitMessage.closeButtonText}
              onClose={() => {
                setCustomSubmitMessage({ show: false });
              }}
              onButtonClicked={() => {
                setCustomSubmitMessage({ show: false });
              }}
            />
          </TabNextButton>
        </div>
        <SuccessTransactionModal />
        <FailureTransactionModal showFailureSubmitModal={showFailureSubmitModal} />
      </SubmitButtonContainer>
    </SubHeaderContainerGcsp>
  );
};

export default SubHeaderGcsp;
